// src/components/tiptap/MenuBar.js

import React, { useRef } from 'react';

export default function MenuBar({ editor, onImageUpload }) {
    if (!editor) {
        return null;
    }

    const fileInputRef = useRef(null);

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            onImageUpload(file);
        }
    };

    const setLink = () => {
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl);

        // cancelled
        if (url === null) {
            return;
        }

        // empty
        if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }

        // update link
        editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
    };

    const menuItems = [
        { action: () => editor.chain().focus().toggleBold().run(), name: 'bold', label: 'B' },
        { action: () => editor.chain().focus().toggleItalic().run(), name: 'italic', label: 'I' },
        { action: () => editor.chain().focus().toggleStrike().run(), name: 'strike', label: 'S' },
        { action: setLink, name: 'link', label: 'LINK' },
        { name: 'image', label: 'IMG' }
    ];

    return (
        <div className="bg-slate-700 p-2 rounded-t-md flex items-center justify-between gap-2 flex-wrap border-b border-slate-600">
            <div className="flex items-center gap-2 flex-wrap">
                {menuItems.map((item, index) => {
                    if (item.name === 'image') {
                        return (
                            <div key={index}>
                                <button
                                    onClick={() => fileInputRef.current.click()}
                                    className='px-3 py-1 rounded font-sans bg-slate-600 hover:bg-slate-500'
                                >
                                    {item.label}
                                </button>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleFileSelect}
                                    className="hidden"
                                    accept="image/png, image/jpeg, image/gif"
                                />
                            </div>
                        );
                    }

                    return (
                        <button
                            key={index}
                            onClick={item.action}
                            className={`px-3 py-1 rounded font-sans
                                ${editor.isActive(item.name) ? 'bg-cyan-500 text-white' : 'bg-slate-600 hover:bg-slate-500'}`
                            }
                        >
                            <span style={{fontWeight: item.name === 'bold' ? 'bold' : 'normal', fontStyle: item.name === 'italic' ? 'italic' : 'normal'}}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
            <span className="text-xs text-slate-400 italic pr-2">
                Shift+Enter para quebra de linha
            </span>
        </div>
    );
}
